// removed by extract-text-webpack-plugin
module.exports = {"holder":"Toolbar_holder--3gQ-V","group":"Toolbar_group--2doO8","group__development":"Toolbar_group__development--Om9VO","groupDevelopment":"Toolbar_group__development--Om9VO","group__economic":"Toolbar_group__economic--3QFpU","groupEconomic":"Toolbar_group__economic--3QFpU","group__disposable":"Toolbar_group__disposable--2ajon","groupDisposable":"Toolbar_group__disposable--2ajon","wrapper":"Toolbar_wrapper--31It1","header":"Toolbar_header--3ea6A","subtitle":"Toolbar_subtitle--3VCMh"};


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Toolbar/Toolbar.scss
// module id = 2213
// module chunks = 11